<i18n>
  {
    "pt_BR": {
      "date": "Criada em {0}",
      "sends": "Quantidade total de SMS Enviados",
      "last": "Últimas mensagens enviadas",
      "received": "Mensagens retornadas",
      "inbound": "Quantidade total de SMS retornado(s)",
      "error": "Mensagens com problemas",
      "token": "RD station token:",
      "without": {
        "sent": "Esta mensagem não possui envios.",
        "error": "Todas as mensagens foram enviadas.",
        "received": "Esta mensagem não tem retorno"
      },
      "edit": "Editar"
    }
  }
</i18n>

<template>
  <section class="details">
    <article class="details-card">
      <template v-if="campaign">
        <header class="details-header">
          <div class="details-header--info">
            <h1 class="details-header--title" v-text="campaign.title"></h1>
            <p class="details-header--date" style="margin-bottom: 2px"  v-text="$t('date', [campaign.created_at])"></p>
            <p class="details-header--date" v-if="campaign.token">NOTIFICAÇÃO ATIVA QUANDO SMS DESTA CAMPANHA FOR RESPONDIDO PELO LEAD</p>
          </div>

          <div class="details-header--action">
            <router-link tag="button" :to="campaign.hash_id + '/edit'" class="details-header--copy-url btnCopyUrl" v-t="'edit'" />
          </div>
        </header>

        <div class="details-message">
          <p class="details-message--bubble" v-text="body"></p>
        </div>
        <div class="campaign-footer--col" style="display: flex">
          <div style="padding-right: 16px">
            <h5 class="campaign-footer--title" v-t="'sends'"></h5>
            <p class="campaign-footer--text" v-text="campaign.sms_count"></p>
          </div>
          <div>
            <h5 class="campaign-footer--title" v-t="'inbound'"></h5>
            <p class="campaign-footer--text" v-text="campaign.inbound_count"></p>
          </div>
        </div>

        <Table
          :title="$t('last')"
          :columns="columns"
          :route="'campaign/' + campaign.id + '/sms'"
          :empty="$t('without.sent')"
          />

        <Table
          :title="$t('error')"
          :columns="columns"
          :extra="errors"
          :route="'campaign/' + campaign.id + '/sms'"
          :empty="$t('without.error')"
          />
          <br/>
          <span>Legendas status: Fonte de endereço inválida, são leads que não contém o número de telefone celular no campo reservado <b>mobile_phone</b> ou <b>personal_phone</b>, no RD Station Marketing. <a href="https://chagbrasil.zendesk.com/hc/pt-br/articles/8452741711373" target="_blank">Saiba mais</a></span>

        <Table
          :title="$t('received')"
          :columns="columns_inbound"
          :extra="inbound"
          :route="'campaign/' + campaign.id + '/sms'"
          :empty="$t('without.received')"
          />
      </template>

      <status :status="campaign" v-else />
    </article>
  </section>
</template>

<script>
  import Table from './Table';
  import Status from '@/Status';
  import Axios from 'core/axios';

  const format = 'DD/MM/YY HH:mm';

  export default {
    components: {
      Table,
      Status,
    },

    props: {
      hash_id: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      campaign: null,

      columns: [
        {
          label: 'Data de Envio',
          field: 'created_at',
          type: 'date',
          dateInputFormat: format,
          dateOutputFormat: format,
        },
        {
          label: 'Nome',
          field: 'name',
        },
        {
          label: 'Telefone',
          field: 'to',
          sortable: false,
        },
        {
          label: 'E-mail',
          field: 'company',
        },
        {
          label: 'Estágio do Funil',
          field: 'stage',
        },
        {
          label: 'Status',
          field: 'status_identifier',
        },
      ],

      columns_inbound: [
        {
          label: 'Data de recebimento',
          field: 'created_at',
          type: 'date',
          dateInputFormat: format,
          dateOutputFormat: format,
        },
        {
          label: 'Nome',
          field: 'name',
        },
        {
          label: 'Telefone',
          field: 'to',
          sortable: false,
        },
        {
          label: 'E-mail',
          field: 'company',
        },
        {
          label: 'Conteúdo da mensagem',
          field: 'body',
        },
        {
          label: 'Status',
          field: 'status_identifier',
        },
      ],

      errors: {
        errors: true,
      },

      inbound: {
        inbound: 1,
      },
    }),

    computed: {
      body () {
        return this.campaign.body.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      },
    },

    created () {
      Axios.get('campaign/' + this.hash_id)
        .then(({ data }) => this.campaign = data.data)
        .catch(() => this.$router.push('/404'))
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Campaign/Show.vue